export default {
    props: ['src', 'alt'],
    template: /*html*/`
        <img :src="src" :alt="alt" />
    `
}